export default "__VITE_ASSET__PHIKNm67__"